export default "__VITE_ASSET__DEedjrsT__"